import { connect } from 'react-redux';

import { openChat } from '../../actions/chat';
import { ECalltrackingWarningType, getCalltrackingWarningTypeExperiment } from '../../experiments/calltrackingWarning';
import { getIsCallbackAvailable, isNewbuildingSelector, selectIsEnabledCallTracking } from '../../selectors';
import { isContractTemplateBlockExperimentEnabledGroupBSelector } from '../../selectors/abExperiments/isContractTemplateBlockExperimentEnabledSelector';
import { disablePhoneButtonSelector } from '../../selectors/disablePhoneButtonSelector';
import { getDynamicCalltrackingSiteBlockId } from '../../selectors/getDynamicCalltrackingSiteBlockId';
import { isDealRent } from '../../selectors/isDealRent';
import { isRenterFormEnabled } from '../../selectors/isRenterFormEnabled';
import { getNewbuildingName } from '../../selectors/newObject';
import { offerChatSelector } from '../../selectors/offerChat';
import { getRosreestrInfo } from '../../selectors/offerData/getRosreestrInfo';
import { IState } from '../../store';
import { prefetchFormState } from '../../store/deal-rent';
import { setPhoneCollapse } from '../../store/phone_collapse';
import { getParent, isPIKOffer } from '../../utils/offer_helpers';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { IOfferContactsAsideDispatchProps, IOfferContactsAsideStateProps, OfferContactsAside } from './index';

function mapStateToProps(state: IState): IOfferContactsAsideStateProps {
  const { abGroup, offerData, bookedOfferId } = state;
  const { agent, agentAvailability, offer, user, kp } = offerData;
  const calltrackingWarningType = getCalltrackingWarningTypeExperiment(state.abUseExperiments);

  return {
    abGroup,
    agent,
    agentAvailability,
    isPhonesVisible: state.printModal.isPhonesVisible,
    kp,
    offer,
    offerChat: offerChatSelector(state),
    parent: getParent(offerData),
    user,
    bookedOfferId,
    isCommercial: isCommercial(getOfferType(offer)),
    isNewBuilding: isNewbuildingSelector(state),
    newbuildingName: getNewbuildingName(state),
    siteBlockId: getDynamicCalltrackingSiteBlockId(state),
    isAuthenticated: !!(state.offerData.user && state.offerData.user.isAuthenticated),
    dynamicCalltrackingPlaceType: 'ContactsAside',
    isDealRent: isDealRent(state),
    entryToShowEnabled: state.entryToShowEnabled,
    isPik: isPIKOffer(offer),
    // Если обяъвление загородки привязано к коттеджному поселку,
    // проверяем возможность отображения телефонов у застройщика.
    shouldRenderContactButtons: kp ? kp.displayBuilderPhone : true,
    shouldRenderCallbackButton: getIsCallbackAvailable(state),
    isDealRentFormEnabled: isRenterFormEnabled(state),
    isCalltrackingEnabled:
      (selectIsEnabledCallTracking(state) &&
        !isNewbuildingSelector(state) &&
        calltrackingWarningType === ECalltrackingWarningType.WARNING) ??
      false,
    /**
     * @todo Удалить блок с экспериментом
     * @description Данный функционал появился в задаче CD-129223, будет удалён в задаче CD-129224
     * Удалить, если эксперимент будет не удачным
     */
    disablePhoneButton: disablePhoneButtonSelector(state),
    rosreestrInfo: getRosreestrInfo(state),
    /**
     * @todo Удалить строку с экспериментом
     * @description Данный функционал появился в задаче CD-138414, будет удалён в задаче CD-138473
     */
    isContractTemplateBlockExperimentEnabled: isContractTemplateBlockExperimentEnabledGroupBSelector(state),
  };
}

// @ts-expect-error TODO: переписать на функциональный компонент
function mapDispatchToProps(dispatch): IOfferContactsAsideDispatchProps {
  return {
    setPhoneCollapse: () => dispatch(setPhoneCollapse()),
    openDealRentForm: () => dispatch(prefetchFormState()),
    openChat: (type?: 'open_phone' | 'open_message') => dispatch(openChat(type)),
  };
}

export const OfferContactsAsideContainer = connect(mapStateToProps, mapDispatchToProps)(OfferContactsAside);
